import React from 'react';
import { useTranslation } from 'react-i18next';
import { CustomButton } from '../../Button/Button';
import styles from './ShareFolderNotification.module.scss';

const ShareFolderNotification = ({ rejectedFolders, onClose }) => {
  const { t } = useTranslation();

  let localStorageUserDetails = localStorage.getItem('userDetails');
  const user = JSON.parse(localStorageUserDetails);

  const contactSupport = () => {
    $crisp.push(['do', 'chat:show']);
    $crisp.push(['do', 'chat:open']);
    onClose();
  };

  return (
    <div className={styles.notificationContainer}>
      <p className={styles.notificationText}>
        {t('share_folder_modal.reject_notification_part1')}
        {rejectedFolders.map(item => (
          <span key={item} className={styles.rejectedEmail}>
            {' '}
            {item},{' '}
          </span>
        ))}
        {t('share_folder_modal.reject_notification_part2')}
        <span className={styles.companyName}>'{user?.companyName}'</span>
        {t('share_folder_modal.reject_notification_part3')}
      </p>
      <div className={styles.btnsContainer}>
        <CustomButton
          label={t('general.contact_support')}
          onClick={contactSupport}
          variant="secondary"
          className={styles.notificationBtn}
        />
        <CustomButton label={'OK'} onClick={onClose} variant="primary" className={styles.notificationBtn} />
      </div>
    </div>
  );
};

export default ShareFolderNotification;
